module.exports = __webpack_public_path__ + "img/balloon.aad39521.svg";